import { useMemo } from 'react';
import { Meteors } from '../shared/Meteors';

/*
 * Pixel-skin backdrop: a night rampart scene (torches on the parapet, hills beyond), with the
 * landing page's starfall and a few twinkling stars on top so the sky stays alive.
 */
export function RampartsBackdrop() {
  const stars = useMemo(() => Array.from({ length: 40 }, () => ({
    x: Math.random() * 100,
    y: Math.random() * 40,
    size: Math.random() < 0.2 ? 3 : 2,
    dur: 2 + Math.random() * 4,
    delay: -Math.random() * 6,
  })), []);

  return (
    <div style={{ position: 'fixed', inset: 0, overflow: 'hidden', pointerEvents: 'none', display: 'var(--pal-backdrop)', background: '#071A22' }}>
      <style>{`
        @keyframes px-twinkle { 0%, 100% { opacity: 0.2; } 50% { opacity: 0.9; } }
        @keyframes torch-flicker { 0%, 100% { opacity: 0.55; } 25% { opacity: 0.8; } 50% { opacity: 0.5; } 75% { opacity: 0.75; } }
      `}</style>
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: 'url(/assets/pixel/ramparts-night.webp)', backgroundSize: 'cover', backgroundPosition: 'center bottom',
        imageRendering: 'pixelated',
      }} />

      {/* Torch glow over the two parapet torches */}
      {[8.5, 91.5].map(x => (
        <div key={x} style={{
          position: 'absolute', left: `${x}%`, bottom: '22%', width: '22vmin', height: '22vmin', transform: 'translate(-50%, 50%)',
          background: 'radial-gradient(circle, rgba(255,170,70,0.35) 0%, rgba(255,120,40,0.12) 40%, transparent 70%)',
          mixBlendMode: 'screen', animation: 'torch-flicker 1.4s steps(4) infinite',
        }} />
      ))}

      {stars.map((s, i) => (
        <span key={i} style={{
          position: 'absolute', left: `${s.x}%`, top: `${s.y}%`, width: s.size, height: s.size,
          background: '#CFF3F8', animation: `px-twinkle ${s.dur}s steps(3) ${s.delay}s infinite`,
        }} />
      ))}

      {/* Starfall, as on the landing page */}
      <div style={{ position: 'absolute', top: '2%', left: 0, right: 0, height: '45%' }}>
        <Meteors number={12} />
      </div>

      {/* Darken toward the content so the rows stay readable */}
      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(3,11,18,0.6) 0%, rgba(3,11,18,0.3) 30%, rgba(3,11,18,0.3) 75%, rgba(3,11,18,0.55) 100%)' }} />
    </div>
  );
}
